import Carousel from './Carousel';
import Slide from './Slide';

Carousel.Slide = Slide;

export { Carousel, Slide };
export default Carousel;
